export const ADD_LIST_TOWER = 'ADD_LIST_TOWER';
export const ADD_TOWER = 'ADD_TOWER';
export const UPDATE_TOWER = 'UPDATE_TOWER';
export const DELETE_TOWER = 'DELETE_TOWER';
export const ADD_LIST_AMENITY = 'ADD_LIST_AMENITY';